import React, { useState,useEffect,useRef } from "react";
import './classes/EditAgent.css';
import Editor from 'react-simple-wysiwyg';
import { configData } from "../config";
import { useNavigate,useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Loading from './Loading';
import Link from '@mui/material/Link';

const EditAgent = ({uid,userLoggedInRoles, userAgentAssets, userSocailMediaAssets,userDetails,userCommonAssets }) => {

  

    const agentCertificateList = [
        'CFL Certified',
        'DEL Certified',
        'FIBA Certified',
        'FIFA Certified',
        'MLB Certified',
        'NBA Certified',
        'NFLPA Certified',
        'NHL Certified',
        'NIL Certified',
        'PHPA Certified',
        'PWHL Certified',
        'WNBA Certified'
    ];

    const initialForm = {
        field_agent_title: '',
        field_agent_biography: '',
        edit_agent_photo_upload: '',
        field_show_on_frontend_agent:0,
        field_delete_photo:0,
        field_agent_photo:'',
        uid:uid,
        field_education: userCommonAssets.field_education,
        field_q_a: userCommonAssets.field_q_a,
        social: {
        field_instagram_url: userSocailMediaAssets?.field_instagram_url || '',
        field_instagram_handle: userSocailMediaAssets?.field_instagram_handle || '',
        field_facebook_url: userSocailMediaAssets?.field_facebook_url || '',
        field_facebook_handle: userSocailMediaAssets?.field_facebook_handle || '',
        field_twitter_url: userSocailMediaAssets?.field_twitter_url || '',
        field_user_youtube_url: userSocailMediaAssets?.field_user_youtube_url || '',
        field_linkedin_url: userSocailMediaAssets?.field_linkedin_url || '',
        field_linkedin_handle: userSocailMediaAssets?.field_linkedin_handle || '',
        },
        field_how_to_contact_client: userCommonAssets.field_how_to_contact_client,
        field_agent_sports: [],
        field_agent_certifications: [],
        field_agent_contract:[],
        field_agent_expiration_year:'',
        field_agent_expiration_month:'',
        field_agent_expiration_date:'',
        removed_fids:[],
        removed_athletes:[],
        field_agent_id:'',
        add_athlete_name:'',
    };

    const [formData, setFormData] = useState(initialForm);
    const [selectedImage, setSelectedImage] = useState(null);
    const [savedImageInfo, setSavedImageInfo] = useState({ size: null});
    const [imageRemoved, setImageRemoved] = useState(false);
    const [imageUploadError, setImageUploadError] = useState('');
    const [useEditor, setUseEditor] = useState(true);
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const[success,setSuccess] = useState({});
	  const [showSocialmediafields, setSocialmediafields] = useState(false);
	  const [editorMode, setEditorMode] = useState({
        biography: true,
        education: true,
        qa: true,
        contact: true,
    });
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [agentuploadFiles, setAgentUploadedFiles] = useState([]);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [buttonText, setButtonText] = useState('Save');
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [athletes, setAthletes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedAthlete, setSelectedAthlete] = useState(null);
    const [deleteReason, setDeleteReason] = useState('');
    const [sportList, setSportList] = useState('');
    const [allAthletes, setAthleteList] = useState([]);
     const [assignedAthletes, setAssignedAthleteList] = useState([]);
    const [searchValue, setSearchValue] = useState('');    
	const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const loggedin_uid = localStorage.getItem('drupal_uid');
     const fileInputRef = useRef(null);

    const [errors, setErrors] = useState([]);
   
    async function getsportslist() {
    
         try {
            const response = await fetch(
                app_url+'smwwagency/agentsports',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
                setSportList(responsedata.data);
               
            } 
        } catch (err) {
            
         }
        
  }

async function getathletelist() {
   
         try {
            const response = await fetch(
                app_url+'report/getsalespersonactivity',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setAthleteList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
async function getassignedathletelist() {
   
         try {
            const response = await fetch(
               app_url+'smwwagency/getassignedathletelist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setAssignedAthleteList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
       
  }
    useEffect(() => {
  const processData = () => {
    if (userAgentAssets.length > 0) {
      userAgentAssets.forEach(item => {
        if (item['key'] === 'field_agent_contract') {
          setAgentUploadedFiles(item['full_value']);
        } 
        else if (item['key'] === 'field_agent_expiration_date' && item['value']) {
          const dateString = item['value'];
        const [date] = dateString.split(" ");
        const [year, month, day] = date.split("-");
            setFormData(prev => ({ ...prev, 
                field_agent_expiration_year:year,
                 field_agent_expiration_month:month,
                field_agent_expiration_date:day,
            
            }));
        }
        else {
          setFormData(prev => ({ ...prev, [item['key']]: item['value'] }));
        }
      });
    }
  };

  const promises = [
    getsportslist(),
    getathletelist(),
    getassignedathletelist(),
  ];

  processData(); // Sync processing
  //console.log(agentuploadFiles.length + "haiiii");

  Promise.all(promises)
    .then(() => {
      setIsLoading(false);
    })
    .catch(error => {
      console.error(error);
      // Handle error
    });
}, [userAgentAssets]);

    useEffect(() => {
        
    // Implement debouncing here if needed
    const fetchData = async () => {
        if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
        }
        try {
        // Replace with your actual API call
        const response = await fetch(app_url+'user/getathletelist?query='+searchValue);
        const data = await response.json();
        setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
        } catch (error) {
        console.error('Error fetching data:', error);
        }
    };

    const handler = setTimeout(() => {
        fetchData();
    }, 500); // Debounce for 500ms

    return () => {
        clearTimeout(handler);
    };
    }, [searchValue]);

    const renderOption = (props, option) => (
    <li {...props}>
        {option.label}
    </li>
    );

    const getOptionLabel = (option) => option?.label || '';

    const onChange = (event, newValue) => {
        console.log('Selected athlete:', newValue);
        setSelectedAthlete(newValue);
       
        setSearchValue(newValue ? newValue.id : ''); 
        setFormData(prev => ({
            ...prev,
            add_athlete_name: newValue ? newValue.id : '',
        }));
    };

    const handleAddAthlete = async () => {
        if (!selectedAthlete) {
            alert("Please select a valid athlete from the list.");
            return;
        }
        
        /* const alreadyAdded = athletes.some(a => String(a.uid) === String(selectedAthlete.uid));
        if (alreadyAdded) {
            alert("Athlete already added.");
            return;
        } */
       const senddata = {
            uid:selectedAthlete.id,
            field_agent_id:formData.field_agent_id,
            agent_drupal_uid:uid
       }
        const response = await fetch(app_url+'editprofile/addathlete', {
        method: 'POST',
      body: JSON.stringify(senddata),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.result === "Success") {
        alert("Done");
         // setAthletes([...athletes, selectedAthlete]);
         getassignedathletelist();

        // Clear input and state
        setSelectedAthlete(null);
        setSearchValue('');
        //setFormData(prev => ({ ...prev, add_athlete_name: '' }));
        setOptions([]);
      }
       
    };
  
    // Open modal
    const handleDeleteClick = (athlete) => {
      
    setSelectedAthlete(athlete);
    setDeleteReason('');
    setShowModal(true);
    };

    // Confirm deletion
    const confirmDelete = async (e) => {
        //console.log(selectedAthlete)
         e.preventDefault();
        //console.log(`Deleting ${selectedAthlete.name} (uid: ${selectedAthlete.id}) for reason: ${deleteReason}`);
       
          const senddata = {
            uid:selectedAthlete.id,
            reason:deleteReason
       }
        const response = await fetch(app_url+'editprofile/dropathlete', {
        method: 'POST',
      body: JSON.stringify(senddata),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.result === "Success") {
        alert("Done");
         //setAthletes(athletes.filter((a) => a.id !== selectedAthlete.id));
         //setAssignedAthleteList(athletes.filter((a) => a.id !== selectedAthlete.id));
         getassignedathletelist();
        setShowModal(false);
        return false;
      }
        
    };

    const toggleEditor = (field) => {
        setEditorMode(prev => ({
            ...prev,
            [field]: !prev[field],
        }));
    };
    
const cleanHtmlOutput = (html) => {
  if (!html) return "";

  // Remove empty p/div/h1-h6 that only contain <br> or spaces
  let cleaned = html.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|&nbsp;|\s)*<\/\1\s*>/gi, "");

  // Remove stray <br>
  cleaned = cleaned.replace(/<br\s*\/?>/gi, "");

  // Check if anything meaningful is left
  const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, "").trim();

  return textOnly.length === 0 ? "" : cleaned.trim();
};
 

const onEditorChange = (field, value) => {
  const cleanedValue = cleanHtmlOutput(value);
  setFormData(prev => ({ ...prev, [field]: cleanedValue }));
};

    const toggleSocialmediafields = () => {
        setSocialmediafields(prev => !prev);
    };
   

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        if (name.startsWith('social.')) {
            const key = name.split('.')[1];
            setFormData(prev => ({
                ...prev,
                social: {
                    ...prev.social,
                    [key]: value
                }
            }));
        } 
        else if (name === "field_show_on_frontend_agent") {
            setFormData(prev => ({ 
                ...prev, 
                [name]: checked ? 1 : 0 
            }));
        } 
        else if (["field_agent_certifications", "field_agent_sports"].includes(name)) {
            // For both certifications and sports, store selected values in array
            setFormData(prev => {
                const current = prev[name] || [];
                const updated = checked
                    ? [...current, value]
                    : current.filter(item => item !== value);

                return {
                    ...prev,
                    [name]: updated
                };
            });
        } 
        else {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    
    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (!file) return;

    //     const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    //     const maxSize = 128 * 1024 * 1024; // 128 MB
    //     const errors = [];

    //     if (!validTypes.includes(file.type)) {
    //         errors.push('Allowed file types: png, gif, jpg, jpeg.');
    //     }

    //     if (file.size > maxSize) {
    //         errors.push('File must be less than 128 MB.');
    //     }

    //     const img = new Image();
    //     const objectUrl = URL.createObjectURL(file);

    //     img.onload = () => {
    //         const { width, height } = img;
    //         if (width < 100 || height < 100 || width > 1000 || height > 1000) {
    //             errors.push('Image size must be 100×100 px to 1000×1000 px.');
    //         }

    //         URL.revokeObjectURL(objectUrl);

    //         if (errors.length > 0) {
    //             alert(errors.join('\n'));
    //             e.target.value = '';
    //             setSelectedImage(null);
    //         } else {
    //             setSelectedImage(file);
    //             setImageRemoved(false); // image selected
    //         }
    //     };

    //     img.onerror = () => {
    //         alert('Failed to load image.');
    //         URL.revokeObjectURL(objectUrl);
    //         e.target.value = '';
    //         setSelectedImage(null);
    //     };

    //     img.src = objectUrl;
    // };
    const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} bytes`;
  } else if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  } else {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
  }
};

    const [tempImage, setTempImage] = useState(null);
  
  // Create and manage preview URL for selectedImage
  const [previewUrl, setPreviewUrl] = useState(null);
  useEffect(() => {
    if (selectedImage) {
      const url = URL.createObjectURL(selectedImage);
      setPreviewUrl(url);
      return () => {
        URL.revokeObjectURL(url);
        setPreviewUrl(null);
      };
    }
    // Clear preview if no selectedImage
    setPreviewUrl(null);
  }, [selectedImage]);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024; // 128 MB
        const errors = [];

        // Check file type
        if (!validTypes.includes(file.type)) {
            errors.push('Allowed file types: png, gif, jpg, jpeg.');
        }

        // Check file size
        if (file.size > maxSize) {
            errors.push('File must be less than 128 MB.');
        }

        // Check image dimensions
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const { width, height } = img;
            if (width < 100 || height < 100 || width > 1000 || height > 1000) {
                errors.push('Image size must be a minimum of 100×100 px and a maximum of 1000×1000 px.');
            }

            URL.revokeObjectURL(objectUrl); // cleanup

            if (errors.length > 0) {
              //  alert(errors.join('\n'));
               const errorHTML = `The selected file <em>${file.name}</em> cannot be uploaded.<br>${errors.join('<br>')}`;
              setImageUploadError(errorHTML);
                e.target.value = ''; // Reset input
                //setSelectedImage(null);
                setTempImage(null);
                 if (fileInputRef.current) fileInputRef.current.value = '';
            } else {
              //  setSelectedImage(file); // Valid image
                 setTempImage(file);
               setImageUploadError(null);
               if (fileInputRef.current) fileInputRef.current.value = '';
            }
        };

        img.onerror = () => {
            //alert('Failed to load image.');
            URL.revokeObjectURL(objectUrl);
             setImageUploadError(`The selected file <em>${file.name}</em> cannot be uploaded. Only files with the following extensions are allowed: <em>png, gif, jpg, jpeg</em>.`);
           // e.target.value = '';
           // setSelectedImage(null);
           setTempImage(null);
            if (fileInputRef.current) fileInputRef.current.value = '';
        };

        img.src = objectUrl;
    };
 const handleUploadClick = () => {
  if (!tempImage) {
      setImageUploadError('No valid image selected.');
      return;
  }

  setSelectedImage(tempImage);
  setTempImage(null);

  // Reset delete photo flag when uploading new image
  setFormData(prev => ({
    ...prev,
    field_delete_photo: 0
  }));
};

 // Remove saved image handler
  const handleRemoveSavedImage = () => {
    setFormData(prev => ({
      ...prev,
      field_delete_photo: 1,
      field_agent_photo: ''
    }));
    setSelectedImage(null);
    setTempImage(null);
    setImageUploadError('');
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

const handleRemoveSelectedImage = () => {
  setSelectedImage(null);
  setTempImage(null);
  setImageUploadError('');
  setFormData(prev => ({
    ...prev,
    field_delete_photo: 1,
  }));
  if (fileInputRef.current) fileInputRef.current.value = '';
};

  useEffect(() => {
  if (formData.field_agent_photo) {
    fetch(formData.field_agent_photo)
      .then(res => res.blob())
      .then(blob => {
       

        const img = new Image();
        img.onload = () => {
          setSavedImageInfo({
             size: blob.size,
          
          });
        };
        img.src = URL.createObjectURL(blob);
      })
      .catch(() => {
        setSavedImageInfo({ size: null });
      });
  }
}, [formData.field_agent_photo]);

    const validTypes = [
        'text/plain',
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx mime type
    ];

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png'; // fallback icon
        }
    };

    const maxSize = 128 * 1024 * 1024;

    const handleFileInputChange = (e) => {
        const files = Array.from(e.target.files);

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;

            if (isValidType && isValidSize) {
                validFiles.push(file);
            } else {
                invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setErrorMessage(
                `The selected file${invalidFiles.length > 1 ? 's' : ''} ${names} cannot be uploaded. Only files with the following extensions are allowed: txt, png, jpg, jpeg, pdf, docx.`
            );
            setFileInputKey(prev => prev + 1); // Reset file input
            setSelectedFiles([]); // Clear selection
        } else {
            setErrorMessage('');
            setSelectedFiles(validFiles);
        }
    };


    const handleUpload = () => {
        // Validate selected files
        const newFiles = selectedFiles.filter(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;
            return isValidType && isValidSize;
        });

        setUploadedFiles(prev => [...prev, ...newFiles]);
        setErrorMessage('');
        setSelectedFiles([]);
        
        // Clear input value by resetting key prop or manually
        // document.getElementById('edit-field-agent-contract').value = '';
        setFileInputKey(prev => prev + 1);
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };
    const removeContractFile = (index,removed_fid) => {
        setAgentUploadedFiles(prev => prev.filter((_, i) => i !== index));
         setFormData(prev => ({
    ...prev,
    removed_fids: [...(prev.removed_fids || []), removed_fid]
  }));
    };

    // const years = Array.from(
    //     { length: 2035 - 2015 + 1 },
    //     (_, i) => {
    //         const year = String(2015 + i);
    //         return { value: year, label: year };
    //     }
    // );
    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 10; 
    const minYear = currentYear - 10;
    const years = Array.from(
        { length: maxYear - minYear + 1 },
        (_, i) => {
            const year = String(minYear + i);
            return { value: year, label: year };
        }
    );

    const months = [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" },
    ];

    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, "0");
        return { value: day, label: day };
    });

    const validateForm = (data) => {
        const errors = [];
        const social = data.social || {};

        if (social.field_linkedin_url?.trim() &&
            !social.field_linkedin_url.toLowerCase().includes('linkedin.com/')) {
            errors.push('Please enter a valid LinkedIn URL');
        }

        if (social.field_instagram_url?.trim() &&
            !social.field_instagram_url.toLowerCase().includes('instagram.com/')) {
            errors.push('Please enter a valid Instagram URL');
        }

        if (social.field_facebook_url?.trim() &&
            !social.field_facebook_url.toLowerCase().includes('facebook.com/')) {
            errors.push('Please enter a valid Facebook URL');
        }

        if (social.field_twitter_url?.trim()) {
            const url = social.field_twitter_url.toLowerCase();
            if (!url.includes('twitter.com/') && !url.includes('x.com/')) {
                errors.push('Please enter a valid Twitter URL');
            }
        }

        if (social.field_user_youtube_url?.trim()) {
            const url = social.field_user_youtube_url.toLowerCase();
            if (!url.includes('youtube.com/') && !url.includes('youtu.be/')) {
                errors.push('Please enter a valid YouTube URL');
            }
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateForm(formData);
        setErrors(errors);
        if (errors.length > 0) {
            setSuccess({});
            window.scrollTo(0, 0);
            return;
        }
        setImageUploadError(''); // clear previous error
        // setErrors([]);
        setButtonText('Submitting...');
        setIsButtonDisabled(true);
        const finalBio = cleanHtmlOutput(formData.field_agent_biography);
        const finalEducation = cleanHtmlOutput(formData.field_education);
        const finalQA = cleanHtmlOutput(formData.field_q_a);
        const finalContact = cleanHtmlOutput(formData.field_how_to_contact_client);

        const updatedFormData = {
        ...formData,
        field_agent_biography: finalBio,
        field_education: finalEducation,
        field_q_a: finalQA,
        field_how_to_contact_client: finalContact,
        };

        const postData = new FormData();
        postData.append('file', selectedImage);
        uploadedFiles.forEach(file => postData.append('contractfiles[]', file));
        postData.append('formData', JSON.stringify(updatedFormData));
        const response = await fetch(app_url+'editprofile/putuseragenteditdetails', {
            method: 'POST',
            body: postData,
        });
        const data = await response.json();
        if(data.data.msg === "Success") {
            setButtonText('Save');
            setIsButtonDisabled(false);
            setSuccess(data.data.result);
            setErrorMessage('');
            setErrors([]);
            window.scrollTo(0, 0);
        }
    };


    const handleCancel = (e) => {
        e.preventDefault();
        const confirmed = window.confirm('Are you sure?');

        if (confirmed) {
            // User clicked "OK", proceed with the action
            console.log('Item deleted successfully!');
            navigate("/user");
            // Add your deletion logic here
        } else {
            // User clicked "Cancel"
          
        }
      
    };

    const removeImage = () => {
        setSelectedImage(null);
        setImageRemoved(true); // track removal
    };

    return (
         <>
                    {isLoading ? (
                        <Loading />
                    ) : (        
        <div className="edit-agent-block">
            {errors.length > 0 && (
                <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`,"padding":"15px 10px 19px 50px"}}>
                    {errors.map((item, index) => {
                        return <>{item}<br /></>
                    })}  
                </div>
            )}
            {success.length > 0 && (
                <>
                    {success.map((item, index) => {
                        return <>
                        <br/><div className="set-message-done">
                         <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: item}}></span>
                        </div></>
                  
                    })}  
                </>
            )}    
            {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
            <form onSubmit={handleSubmit}>
                {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_AGENT)) && (
                    <>            
                        <div className="form-item">
                            <label htmlFor="edit-agent-job-title">Agent Job Title</label>
                            <input
                                className="edit-agent-form-input"
                                type="text"
                                id="edit-agent-job-title"
                                name="field_agent_title"
                                maxLength={255}
                                value={formData.field_agent_title}
                                onChange={handleChange}
                            />
                        </div>

                  
                        <div className="form-item">
                       {imageUploadError && (
                        <div 
                            style={{ color: '#d9534f', 
                            border: '1px solid #d9534f',
                            backgroundColor: '#fef5f1', 
                            padding: '10px 10px 10px 50px', 
                            marginBottom: '10px',
                            width: '90%', 
                            borderRadius: '5px',
                        background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat` }}
                            dangerouslySetInnerHTML={{ __html: imageUploadError }}
                            >
                        
                        </div>
                        )}
                            <label htmlFor="edit-agent-photo-upload">Agent Photo</label>
                            <div>
                                {formData.field_agent_photo ? (
                                    <>
                                        <div className="edit-agent-image-container">
                                            <img
                                                alt="Uploaded"
                                                src={formData.field_agent_photo}
                                                width="90" height="100"
                                            />
                                            <div className="image-info">
                                                <a
                                                    href={formData.field_agent_photo}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                >
                                                                                                         <img
                                                    src={getFileIcon(formData.field_agent_photo)}
                                                    alt="File Icon"
                                                    style={{ width: '16px', height: '16px', marginRight: '5px', verticalAlign: 'middle' }}
                                                />
                                                    {formData.field_agent_photo.replace("/basic/web/pictures/", "")}
                                                </a>
                                                 {savedImageInfo.size && (
                                                <span className="image-size">
                                                    {' '}({formatFileSize(savedImageInfo.size)})
                                                </span>
                                                )}
                                            </div>
                                        </div>
                                        <input
                                            type="button"
                                            value="Remove"
                                            className="form-submit"
                                             onClick={handleRemoveSavedImage}
                                           // onClick={() => setFormData((prev) => ({ ...prev, field_delete_photo:1,field_agent_photo:'' }))}
                                        />
                                    </>
                                ) : selectedImage ? (
                                    <>
                                        <div className="edit-agent-image-container">
                                            <img alt="Uploaded" src={URL.createObjectURL(selectedImage)} />
                                            <div className="image-info">
                                                <a
                                                    href={URL.createObjectURL(selectedImage)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="image-name-link"
                                                >
                                                    {selectedImage.name}
                                                </a>
                                              <span className="image-size">
                                                 {' '}({formatFileSize(selectedImage.size)})
                                                </span>
                                            </div>
                                        </div>
                                        <input
                                            type="button"
                                            value="Remove"
                                            className="form-submit"
                                            //onClick={removeImage}
                                            onClick={handleRemoveSelectedImage}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <input
                                            type="file"
                                            id="edit-agent-photo-upload"
                                            name="edit_agent_photo_upload"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                        />
                                        <input
                                            type="button"
                                            value="Upload"
                                            className="form-submit"
                                            // onClick={() =>
                                            // document.getElementById('edit-agent-photo-upload').click()
                                            // }
                                            onClick={handleUploadClick}
                                        />
                                    </>
                                )}
                            </div>

                            <div className="description">
                                Image size must be a minimum of 100*100 px or a maximum of 1000*1000 px<br />
                                Files must be less than <b>128 MB</b>.<br />
                                Allowed file types: <b>png gif jpg jpeg</b>.
                            </div>
                        </div>
                        {/* Q&A */}
                        <div className="form-item">
                            <label>Q&A</label>
                            {editorMode.qa ? (
                                <Editor value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
                            ) : (
                                <>
                                    <textarea className="edit-agent-form-bio" value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
                                        <div
                                            className="grippie" 
                                            style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                        >
                                        </div>
                                </>
                          )}
                        
                          <a onClick={() => toggleEditor('qa')}>Switch to {editorMode.qa ? 'Plain' : 'Rich'} Editor</a>
                        </div>
                        {/* Biography */}
                        <div className="form-item">
                            <label htmlFor="edit-agent-biography">Agent Biography</label>
                            <div>
                                {useEditor ? (
                                    <Editor
                                        containerProps={{ style: { resize: 'vertical' } }}
                                        value={formData.field_agent_biography} 
                                        onChange={(e) => setFormData((prev) => ({ ...prev, field_agent_biography: e.target.value })) }
                                    />
                                ) : (
                                    <>
                                        <textarea
                                            className="edit-agent-form-bio"
                                            id="edit-agent-biography"
                                            name="field_agent_biography"
                                            value={formData.field_agent_biography} 
                                            rows={5}
                                            onChange={(e) => setFormData((prev) => ({ ...prev, field_agent_biography: e.target.value })) }
                                        />
                                        <div
                                          className="grippie"
                                          style={{ background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px` }}
                                        >
                                        </div>
                                    </>
                                )}
                                <a onClick={() => setUseEditor(!useEditor)} style={{ cursor: 'pointer' }}>
                                    Switch to {useEditor ? "Plain Text Editor" : "Rich Text Editor"}
                                </a>
                            </div>
                        </div>
                
                        {/* Education */}
                        <div className="form-item">
                            <label>Education</label>
                            {editorMode.education ? (
                                <Editor value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                            ) : (
                              <>
                                  <textarea className="edit-agent-form-bio" value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                                  <div
                                      className="grippie" 
                                      style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                  >
                                  </div>
                              </>
                            )}
                            <a onClick={() => toggleEditor('education')}>Switch to {editorMode.education ? 'Plain' : 'Rich'} Editor</a>
                        </div>
                        {/* Social Media Fields */}
                        <fieldset className="edit-agent-fieldset" style={{border:"1px solid #111",padding:"10px"}}>
                            <legend onClick={toggleSocialmediafields} style={{color:"#2c99d2", cursor:"pointer"}}>
                                <span style={{ fontSize: '10px',color:"#111" }}>{showSocialmediafields ? '▼' : '▶'}</span> Social Media
                            </legend>
                            {showSocialmediafields && (
                                <div className="fieldset-wrapper">
                                    {[
                                        ['field_instagram_url', 'Instagram URL'],
                                        ['field_instagram_handle', 'Instagram Handle'],
                                        ['field_facebook_url', 'Facebook URL'],
                                        ['field_facebook_handle', 'Facebook Handle'],
                                        ['field_twitter_url', 'Twitter URL'],
                                        ['field_user_youtube_url', 'YouTube URL'],
                                        ['field_linkedin_url', 'LinkedIn URL'],
                                        ['field_linkedin_handle','LinkedInHandle']
                                    ].map(([key, label]) => (
                                        <div className="form-item" key={key}>
                                            <label>{label}</label>
                                            {key === 'field_linkedin_url' ? (
                                                <>
                                                    <textarea
                                                        className="edit-agent-form-bio"
                                                        name={`social.${key}`}
                                                        value={formData.social[key]}
                                                        onChange={handleChange}
                                                        rows={4}
                                                    />
                                                    <div
                                                        className="grippie" 
                                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                                    >
                                                    </div>
                                                </>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="text-full form-text"
                                                    name={`social.${key}`}
                                                    value={formData.social[key]}
                                                    onChange={handleChange}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </fieldset>
                        {/* How to Contact */}
                        <div className="form-item">
                            <label>How to Contact</label>
                            {editorMode.contact ? (
                                <Editor value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} />
                            ) : (
                                <>
                                    <textarea className="edit-agent-form-bio" value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                </>
                            )}
                            <a onClick={() => toggleEditor('contact')}>Switch to {editorMode.contact ? 'Plain' : 'Rich'} Editor</a>
                        </div>
                    </>
                )}
                {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) && (
                    <>  
                    <div className="" id="edit-field-agent-sports">
	                    <div className="form-item">
                            <label htmlFor="field-agent-sports">Agent Sports </label>    
                            {sportList.length > 0 && (
                                <>
                                    {sportList.map((sportName) => (
                                        <label key={sportName} className="sports-checkbox-item">
                                            <input
                                                type="checkbox"
                                                name="field_agent_sports"
                                                value={sportName.key}
                                                onChange={handleChange}
                                                checked={formData.field_agent_sports?.includes(sportName.key)}                                           
                                                className="sport-list-input"
                                            />
                                            {sportName.value}
                                        </label>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                    <div className="" id="edit-field-agent-certifications">
                        <div className="form-item">
                            <label htmlFor="field-agent-certifications">Agent Certifications </label>
                            {agentCertificateList.length > 0 && (
                                <>
                                    {agentCertificateList.map((certificateName) => (
                                        <label key={certificateName} className="sports-checkbox-item">
                                            <input
                                                type="checkbox"
                                                name="field_agent_certifications"
                                                value={certificateName}
                                                checked={formData.field_agent_certifications?.includes(certificateName)}
                                                onChange={handleChange}                                             
                                                className="sport-list-input"
                                            />
                                            {certificateName}
                                        </label>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                    <div id="edit-field-agent-contract">
                        <div>
                            <fieldset className="form-wrapper">
                                <legend>
                                  <span style={{fontWeight:"700"}}>Agent Contract</span>
                                </legend>
                                <div className="fieldset-wrapper">
                                    {(uploadedFiles?.length > 0 || agentuploadFiles?.length > 0) && (
                                        <table className="" style={{fontSize:"14px", width:"90%"}}>
                                            <thead>
                                                <tr style={{textAlign:"left"}}>
                                                <th>File information</th>
                                                <th>Operations</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{backgroundColor: "#eee"}}>
                                                
                                                {uploadedFiles.length > 0 && uploadedFiles.map((file, index) => (
                                                <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                                    <td>
                                                    <span className="file">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(file.name)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                        {file.name}
                                                        </a>
                                                    </span>
                                                    <span> ({formatFileSize(file.size)})</span>
                                                    </td>
                                                    <td>
                                                    <button
                                                        type="button"
                                                        className="form-submit"
                                                        onClick={() => removeFile(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                    </td>
                                                </tr>
                                                ))}
                                                {agentuploadFiles && 
                                                 agentuploadFiles.length > 0 && agentuploadFiles.map((file, index) => (
                                                <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                                    <td>
                                                    <span className="file">
                                                        <img
                                                            className="file-icon"
                                                            alt="File icon"
                                                            src={getFileIcon(file.name)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <a href={file.url} target="_blank" rel="noreferrer">
                                                        {file.name}
                                                        </a>
                                                    </span>
                                                    <span> ({formatFileSize(file.size)})</span>
                                                    </td>
                                                    <td>
                                                    <button
                                                        type="button"
                                                        className="form-submit"
                                                        onClick={() => removeContractFile(index,file.fid)}
                                                    >
                                                        Remove
                                                    </button>
                                                    </td>
                                                </tr>
                                                ))}
                                            
                                            </tbody>
                                        </table>
                                    )}
                                    {errorMessage && (
                                        <div 
                                            className="set-message-error" 
                                            style={{ 
                                                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                                padding: "10px 10px 10px 50px",
                                                width: "90%",
                                            }}
                                        >
                                            {errorMessage}
                                        </div>
                                    )}
                                    <div className="form-item">
                                        <label htmlFor="edit-field-agent-contract">Add a new file</label>
                                        <div>
                                            <input
                                                type="file"
                                                id="edit-field-agent-contract"
                                                name="field_agent_contract"
                                                className="form-file"
                                                multiple
                                                onChange={handleFileInputChange}
                                                key={fileInputKey}
                                            />
                                            <button type="button" onClick={handleUpload} disabled={selectedFiles.length === 0} className="form-submit">
                                                Upload
                                            </button>
                                        </div>
                                        <div className="description">
                                            Files must be less than <strong>128 MB</strong>.<br />
                                            Allowed file types: <strong>txt, png, jpg, jpeg, pdf, docx</strong>.
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="form-item">
                        <input
                            type="checkbox"
                            id="edit-field-show-on-frontend-agent-und"
                            name="field_show_on_frontend_agent"
                            checked={formData.field_show_on_frontend_agent === 1}
                            // defaultChecked={formData.field_show_on_frontend_agent === "1" ? "true":"false"}
                            onChange={handleChange}
                            className="form-checkbox"
                        />
                        <label className="option" htmlFor="edit-field-show-on-frontend-agent-und" style={{fontWeight:"normal"}}>
                            Show on Frontend Agent
                        </label>
                    </div>
                    <div className="form-item">
                        <fieldset>
                            <legend>
                                <span className="">Agent Expiration Date </span>
                            </legend>
                            <div className="agent-expiry-date form-item">
                                <div className="form-type-select">
                                    <label htmlFor="edit-field-agent-expiration-date-year">Year </label>
                                    <select 
                                        name="field_agent_expiration_year"
                                        value={formData.field_agent_expiration_year}
                                        onChange={handleChange}
                                    >
                                        <option value=""></option>
                                        {years.map((y) => (
                                            <option key={y.value} value={y.value}>
                                            {y.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-type-select">
                                    <label htmlFor="edit-field-agent-expiration-date-month">Month </label>
                                    <select 
                                        name="field_agent_expiration_month"
                                        value={formData.field_agent_expiration_month}
                                        onChange={handleChange}                    
                                    >
                                        <option value=""></option>
                                        {months.map((m) => (
                                            <option key={m.value} value={m.value}>
                                            {m.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-type-select">
                                  <label htmlFor="edit-field-agent-expiration-date-day">Day </label>
                                  <select  
                                    name="field_agent_expiration_date"
                                    value={formData.field_agent_expiration_date}
                                    onChange={handleChange}                    
                                  >
                                      <option value=""></option>
                                      {days.map((d) => (
                                        <option key={d.value} value={d.value}>
                                          {d.label}
                                        </option>
                                      ))}                
                                  </select>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div style={{ marginTop: "40px" }}>
                        <span><b>Add Athlete to Agent:</b></span><br />
                        <div style={{ position: "relative", width: "100%" }}>
                            <div style={{float:"left", width: "60%"}}>
                                <Autocomplete
                                    id="add_athlete_name"
                                    disablePortal
                                    options={options}
                                    sx={{ 
                                        width: "98%", 
                                        backgroundColor:"#fff",
                                        border: "1px solid #ccc",
                                        // maxHeight: "20px" 
                                        display: "inline-block"
                                    }}
                                    renderOption={renderOption}
                                    getOptionLabel={getOptionLabel}
                                    onChange={onChange}
                                    value={selectedAthlete}
                                    inputValue={searchValue}
                                    onInputChange={(event, newInputValue) => setSearchValue(newInputValue)}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                />
                            </div>
                            <div style={{float:"left", width: "40%"}}>
                                <input
                                    type="button"
                                    value="Add"
                                    style={{ marginLeft: "5px" }}
                                    onClick={handleAddAthlete}
                                />
                            </div>
                            <div style={{clear:"both"}}></div>
                        </div>
                        <table style={{ marginTop: "20px", fontSize: "14px", textAlign: "left", width: "90%" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "70%" }}>Athletes represented by {userDetails.first_name && userDetails.last_name ? (
                                        userDetails.first_name+' '+userDetails.last_name
                                    ) : (
                                        userDetails.username
                                    )
                                }</th>
                                    <th style={{ width: "30%" }}>Delete</th>
                                </tr>
                            </thead>
                            <tbody style={{backgroundColor: "#eee"}}>
                                
                                {assignedAthletes.map((athlete, index) => (
                                    <tr key={index} style={{borderBottom: "1px solid #ccc"}}>
                                        <td><a href={"/view_athlete/"+athlete.id}>{athlete.name}</a></td>
                                        <td>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleDeleteClick(athlete); }}>
                                                Delete
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {showModal && (
                            <div id="editModal" className="modal view-event-modal edit-modal-all">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h2>Drop Athlete</h2>
                                        <span className="close" onClick={() => setShowModal(false)}>×</span>
                                    </div>
                                    <div className="modal-body edit-model">
                                        <p>Please specify why you're dropping <b>{selectedAthlete.name}</b>:</p>
                                        <div style={{ marginBottom: "10px" }}>
                                            <textarea
                                                type="text"
                                                value={deleteReason}
                                                onChange={(e) => setDeleteReason(e.target.value)}
                                                style={{ width: "100%", marginTop: "5px", height:"100px" }}
                                            />
                                        </div>
                                        <div className="form-item">
                                            <button onClick={confirmDelete}>Drop Athlete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    </>
                )}
                {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) || userLoggedInRoles.includes(configData.ROLE_AGENT)) && (
                    <>               
                        <div className="form-actions">
                            <input type="submit" className="form-submit" value={buttonText}  disabled={isButtonDisabled} />
                            <input
                                type="button"
                                value="Cancel account"
                                className="edit-agent-form-cancel"
                                onClick={handleCancel}
                                style={{ background: `#999 url("/basic/web/images/overlay.png") repeat-x` }}
                            />
                        </div>
                    </>
                )}                
              
            </form>
            ) : (
                <><p>You are not authorized</p></>   
            )}
        </div>
                    )}
                    </>
    );
};

export default EditAgent;